module.exports = __webpack_public_path__ + "img/backup.d8e32373.png";